import ViewReportFile from "./component";
import ViewReportFileContainer from "./container";

export { ViewReportFile, ViewReportFileContainer };
export default ViewReportFileContainer;



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReportFiles/index.ts